import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-icon-clock',
    templateUrl: './icon-clock.component.html',
    styleUrls: ['./icon-clock.component.scss']
})
export class IconClockComponent implements OnInit {

    @Input() cssClass: string;

    constructor() { }

    ngOnInit(): void {
    }

}
